// extracted by mini-css-extract-plugin
export var btn = "L_mB t_sc t_r6 d_bz d_bP d_bD d_dw";
export var full = "L_vX d_w d_H";
export var hoverStyle = "L_mF";
export var zoom = "L_mG";